import { readRemembered, writeRemembered } from "../../../shared/lib/remembered";
import { PUB_FORMATS } from "./domain";

/**
 * Что человек выбирал в этом направлении в прошлый раз: аккаунты, формат,
 * автопубликацию. Публикации в одно направление ставят пачками на одни и те
 * же каналы — выбирать их каждый раз заново незачем (как rememberProject).
 */
export type DirectionPrefs = { accountIds?: string[]; format?: string; autoPublish?: boolean };

const key = (projectId: string) => `montage:direction:${projectId}`;

export function readDirectionPrefs(projectId: string | null | undefined): DirectionPrefs {
  return projectId ? readRemembered<DirectionPrefs>(key(projectId), {}) : {};
}

export function rememberDirectionPrefs(projectId: string | null | undefined, prefs: DirectionPrefs): void {
  if (!projectId) return;
  writeRemembered(key(projectId), { ...readDirectionPrefs(projectId), ...prefs });
}

/** Формат из запомненного — только если он ещё есть в списке. */
export const knownFormat = (f: string | undefined): string => (f && PUB_FORMATS.some((x) => x.value === f) ? f : PUB_FORMATS[0].value);
